import { FC, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ConditionSelectorModal from "../../Business/Service/DiscountConditionType/ConditionSelectorModal";
import CommandsPanel from "../../hoc/CommandsPanel/CommandsPanel";
import { IEntitySimpleDTO } from "../../libs/coreapi-dto/@types/common";
import { ClearButton, Delete2Button } from "../buttons/iconButtons/action/MainCollection";
import GridSelectorInput from "../controls/GridSelectorInput";
import { BaseModalWindow } from "../modalWindows/BaseModalWindow";
import GridMultipleSelectorInput from "../controls/GridMultipleSelectorInput";
import GridWrapper from "../controls/GridWrapper";
import { SelectControl } from "../controls/SelectControl";
import { DefaultGrid } from "../grids/default/defaultGrid";
import { IOption } from "./select";
import { v4 as uuidv4 } from "uuid";
import styles from "../selects/discountCondition.module.scss";
import useGridFilter from "../../system/hooks/useGridFilter";
import { TextInput } from "../controls/inputs";
import { GoodsGroupAllSelectorModal } from "../../Business/Dictionaries/GoodsGroup/GoodsGroupAllSelectorModal";
import StoreSelectorModal from "../../Business/Dictionaries/Store/StoreSelectorModal";
import GoodsSelectorModal from "../../Business/Dictionaries/Goods/GoodsSelectorModal";
import { DateInput, DecimalInputV2, NumberInput } from "../controls/inputs/BaseInput";
import { DateTime } from "luxon";
import ProducerSelectorModal from "../../Business/Dictionaries/Producer/ProducerSelectorModal";
import { FilePlusButton } from "../buttons/iconButtons/other/FileAndFolderCollection";
import { HighLightButton } from "../buttons/iconButtons/editor/ActionCollection";
import { StoreTypeSelectorModal } from "../../Business/Dictionaries/StoreType";
import { ContractorGroupAllSelectorModal } from "../../Business/Dictionaries/ContractorGroup/ContractorGroupAllSelectorModal";
import FlexRow from "../controls/FlexRow";
import DayOfTheWeekSelectorModal from "./DayOfTheWeekSelectorModal";

export interface IDisplayItem {
    id: string;
    condition: string;
}

enum updateOrAdd {
    update = "update",
    add = "add",
}

export interface IProps {
    value: string;
    conditionType: IEntitySimpleDTO;
    rowValue: any;
    operation: IOption;
    text: string;
    updateOrAdd: updateOrAdd;
}

interface IConditionProps {
    conditionJoinType: string;
    plugin: IPluginSettings;
    displayItem: IDisplayItem[];
    onConditionJoinType: (conditionJoinType: IOption) => void;
    onClick: (props: IProps) => void;
    onRemoveCondition: (rowValue: any) => void;
    onClearConditions: () => void;
    lockFromPermission?: boolean;
}

interface IValue {
    displayValue: string;
    value;
}

export interface IDisplayAccumulationSchemaItem {
    idGlobal: string;
    accumulationSumFrom: number;
    accumulationSumTo: number;
    discountValue: number;
    IdDiscountCardTypeGlobal: string;
}

export const DiscountConditionForm: FC<IConditionProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t("directory.discountCardType." + value);

    const [conditionValueComp, setConditionValueComp] = useState(<></>);
    const [conditionType, setConditionType] = useState<IEntitySimpleDTO>({} as IEntitySimpleDTO);
    const [selectEntity, setSelectEntity] = useState<IEntitySimpleDTO>({} as IEntitySimpleDTO);

    const [timeFrom, setTimeFrom] = useState<string>("");
    const [timeTo, setTimeTo] = useState<string>("");

    const [sumFrom, setSumFrom] = useState<number>(0);
    const [sumTo, setSumTo] = useState<number>(0);

    const [quantityFrom, setQuantityFrom] = useState<number>(0);
    const [quantityTo, setQuantityTo] = useState<number>(0);

    const [value, setValue] = useState<IValue | undefined>(undefined);
    const [operation, setOperation] = useState<IOption>();
    const [operationOption, setOperationOption] = useState<IOption[]>([]);
    const [btnAddEditCondition, setBtnAddEditCondition] = useState(<></>);
    const [btnText, setBtnText] = useState<string>("Добавить условие");
    const [displayItems, setDisplayItems] = useState<IDisplayItem[]>(props.displayItem);
    const [selectedItem, setSelectedItem] = useState<IGridRow | undefined>();
    const [contractorEntities, setContractorEntities] = useState<IEntitySimpleDTO[]>([]);
    const [storeEntities, setStoreEntities] = useState<IEntitySimpleDTO[]>([]);
    const [goodsEntities, setGoodsEntities] = useState<IEntitySimpleDTO[]>([]);
    const [goodsGroupEntities, setGoodsGroupEntities] = useState<IEntitySimpleDTO[]>([]);
    const [storeTypeEntities, setStoreTypeEntities] = useState<IEntitySimpleDTO[]>([]);
    const [producerEntities, setProducerEntities] = useState<IEntitySimpleDTO[]>([]);
    const [dayOfTheWeekEntities, setDayOfTheWeekEntities] = useState<IEntitySimpleDTO[]>([]);
    const [light, setLight] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editText, setEditText] = useState<string>("");
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [dateCondition, setDateCondition] = useState<DateTime | undefined | null>(DateTime.now());
    const [dateConditionFrom, setDateConditionFrom] = useState<DateTime | undefined | null>(DateTime.now());
    const [dateConditionTo, setDateConditionTo] = useState<DateTime | undefined | null>(DateTime.now());

    const JnvlsOptios: IOption[] =   [
        { displayName: "Да", value: 1 },
        { displayName: "Нет", value: 0 },
    ] as IOption[]

    const conditionJoinTypeOption: IOption[] = [
        { displayName: "И", value: "AND" },
        { displayName: "ИЛИ", value: "OR" },
    ] as IOption[];
    const [conditionJoinType, setConditionJoinType] = useState<IOption>(conditionJoinTypeOption.find((c) => c.value == props.conditionJoinType) as IOption);

    const allOperators = [
        { displayName: "Содержит", value: "%like%", conditionTypes: [] },
        { displayName: "Равно", value: "=", conditionTypes: ["Цена", "Сумма с учетом скидки", "Сумма", "Дата", "ЖВ","Срок годности","Разукомплектован","Количество"] },
        { displayName: "Не равно", value: "!=", conditionTypes: ["Цена", "Сумма с учетом скидки", "Сумма", "Дата","Срок годности","Количество"] },
        { displayName: "Больше", value: ">", conditionTypes: ["Цена", "Сумма с учетом скидки", "Сумма", "Время", "Дата","Срок годности","Количество"] },
        { displayName: "Больше или равно", value: ">=", conditionTypes: ["Цена", "Сумма с учетом скидки", "Сумма", "Время", "Дата","Срок годности","Количество"] },
        { displayName: "Меньше", value: "<", conditionTypes: ["Цена", "Сумма с учетом скидки", "Сумма", "Время", "Дата","Срок годности","Количество"] },
        { displayName: "Меньше или равно", value: "<=", conditionTypes: ["Цена", "Сумма с учетом скидки", "Сумма", "Время", "Дата","Срок годности","Количество"] },
        { displayName: "Начинается с", value: "like%", conditionTypes: [] },
        { displayName: "Список значений", value: "in", conditionTypes: ["День недели", "Производитель", "Группа товара", "Группа аптек глобально", "Склад", "Товар","Тип склада"] },
        { displayName: "Между", value: "between", conditionTypes: ["Сумма с учетом скидки", "Время", "Цена", "Сумма", "Дата", "Количество", "Срок годности"] },
        { displayName: "Заканчивается на", value: "%like", conditionTypes: [] },
    ];

    useEffect(() => {
        setBtnAddEditCondition(addButton());
    }, []);

    useEffect(() => {
        if (selectedItem) {
            setBtnText("Изменить условие");
            setBtnAddEditCondition(editButton());
        } else {
            setBtnText("Добавить условие");
            setBtnAddEditCondition(addButton());
        }
    }, [value, conditionType, operation, selectedItem]);

    useEffect(() => {
        const operatorList: IOption[] = allOperators.filter((item) => item.conditionTypes.indexOf(conditionType?.displayName) >= 0);
        setOperationOption([...operatorList]);
        setOperation(operatorList.length ? operatorList[0] : ({} as IOption));
        renderConditionComp();
    }, [conditionType, selectEntity]);

    useEffect(() => {
        renderConditionComp();
    }, [operation]);

    useEffect(() => {
        if (timeFrom === "" || timeTo === "") {
            return;
        }
        const value = "От: " + timeFrom + " До: " + timeTo
        setValue({ displayValue: value, value : value});
    }, [timeTo, timeFrom]);

    useEffect(() => {
        if ((conditionType.displayName !== "Дата" && conditionType.displayName !== "Срок годности") || operation?.displayName !== "Между") return;
        if (!dateConditionFrom || !dateConditionTo) return;
        const from = dateConditionFrom.toFormat("yyyy-MM-dd");
        const to = dateConditionTo.toFormat("yyyy-MM-dd");
        setValue({ displayValue: from + " и " + to, value: from + " и " + to });
    }, [dateConditionFrom, dateConditionTo]);

    useEffect(() => {
        const isSumCondition = conditionType.displayName === "Цена" || conditionType.displayName === "Сумма" || conditionType.displayName === "Сумма с учетом скидки";
        if (!isSumCondition || operation?.displayName !== "Между") return;
        const value = sumFrom + " и " + sumTo
        setValue({ displayValue: value, value : value});
    }, [sumFrom, sumTo]);

    useEffect(() => {
        if (conditionType.displayName !== "Количество" || operation?.displayName !== "Между") return;
        const value = quantityFrom + " и " + quantityTo
        setValue({ displayValue: value, value : value});
    }, [quantityFrom, quantityTo]);

    const editButton = (): SetStateAction<JSX.Element> => {
        return (
            <HighLightButton
                sizeVariant="mini"
                onClick={() => {
                    setEditText(selectedItem?.cells[0].value ?? "");
                    setShowEditModal(true);
                }}
                disabled={props.lockFromPermission}
            />
        );
    };

    const addButton = (): SetStateAction<JSX.Element> => {
        return (
            <FilePlusButton
                sizeVariant="mini"
                onClick={() => {
                    setLight(true);
                    setTimeout(() => {
                        setLight(false);
                    }, 1000);

                    let text = "[" + conditionType.displayName + "] " + operation?.displayName + " [" + value?.displayValue + "]";
                    if (text.includes("undefined")) {
                        return;
                    }
                    addCondition(text);
                }}
                disabled={props.lockFromPermission}
            />
        );
    };

    function updateCondition(text: string) {
        if (displayItems.filter((item) => item.condition == text).length == 0) {
            setDisplayItems([...displayItems.filter((item) => item.condition != selectedItem?.cells[0].value), { condition: text, id: selectedItem?.id } as IDisplayItem]);

            props.onClick({
                value: value?.value,
                conditionType: conditionType,
                rowValue: selectedItem?.cells[0].value,
                operation: operation,
                text: text,
                updateOrAdd: "update",
            } as IProps);

            setBtnAddEditCondition(addButton());
            setBtnText("Добавить условие");
        }
    }

    function addCondition(text: string) {
        if (displayItems.filter((item) => item.condition == text).length == 0) {
            setDisplayItems([...displayItems, { condition: text, id: selectedItem?.idRow } as IDisplayItem]);
            props.onClick({
                value: value?.value,
                conditionType: conditionType,
                rowValue: selectedItem?.cells[0].value,
                operation: operation,
                text: text,
                updateOrAdd: "add",
            } as IProps);
        }
    }

    function renderConditionComp() {
        switch (conditionType.displayName) {
            case "День недели": {
                renderDayOfTheWeekComp();
                break;
            }
            case "Время": {
                renderTimeValueComp();
                break;
            }
            case "Сумма": {
                renderNumberValueComp();
                break;
            }
            case "Цена": {
                renderNumberValueComp();
                break;
            }
            case "Группа аптек глобально": {
                renderContractorComp();
                break;
            }
            case "Группа товара": {
                renderGoodsGroupComp();
                break;
            }
            case "Склад": {
                renderStoreComp();
                break;
            }
            case "Товар": {
                renderGoodsComp();
                break;
            }
            case "Дата": {
                renderDateComp();
                break;
            }
            case "Производитель": {
                renderProducerComp();
                break;
            }
            case "Сумма с учетом скидки": {
                renderNumberValueComp();
                break;
            }
            case "ЖВ": {
                renderBoolComp();
                break;
            }
            case "Тип склада": {
                renderStoreTypeComp();
                break;
            }
            case "Срок годности": {
                renderDateComp();
                break;
            }
            case "Разукомплектован": {
                renderBoolComp();
                break;
            }
            case "Количество": {
                renderQuantityValue();
                break;
            }
            default: {
                setConditionValueComp(<></>);
            }
        }
    }

    function renderDayOfTheWeekComp(): void {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={DayOfTheWeekSelectorModal}
                id={`inputAccompanyingSelectionDayOfTheWeek-${uuidv4()}`}
                inline={false}
                selectedEntity={dayOfTheWeekEntities[0]}
                selectedEntities={dayOfTheWeekEntities}
                label={baseT("conditionDayOfTheWeekValue")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setDayOfTheWeekEntities(entities);
                    setValue(entities.length > 0 ? {
                        value: entities.map((entity) => entity.idGlobal).join(','),
                        displayValue: entities.map((entity) => entity.displayName).join(', '),
                    } : undefined);
                }}
                onClear={() => {
                    setDayOfTheWeekEntities([]);
                    setValue(undefined);
                }}
                disabled={props.lockFromPermission}
            />
        );
    }

    function renderTimeValueComp() {
        setValue(undefined);
        setConditionValueComp(
            operation?.displayName !== "Между" ? (
                <div>
                    <TextInput
                        type="time"
                        label={baseT("conditionTimeValue")}
                        onChange={(value) => {
                            setValue({displayValue: value, value: value});
                        }}
                    />
                </div>
            ) : (
                <div>
                    <TextInput
                        type="time"
                        label={baseT("conditionTimeValue") + " От"}
                        onChange={(value) => {
                            setTimeFrom(value);
                        }}
                    />
                    <TextInput
                        type="time"
                        label={baseT("conditionTimeValue") + " До"}
                        onChange={(value) => {
                            setTimeTo(value);
                        }}
                    />
                </div>
            )
        );
    }

    function renderNumberValueComp() {
        const isBetween = ((conditionType.displayName === "Цена") || (conditionType.displayName === "Сумма") || (conditionType.displayName === "Сумма с учетом скидки")) && (operation?.displayName === "Между");
        if (isBetween) {
            setValue({ displayValue: "0 и 0", value: "0 и 0" });
        } else {
            setValue({ displayValue: "0.00", value: "0.00" });
        }
        setConditionValueComp(
            (((conditionType.displayName === "Цена") || (conditionType.displayName === "Сумма")) && (operation?.displayName === "Между")) ?
                <FlexRow>
                    <div>
                        <DecimalInputV2
                            label={"От"}
                            onChange={(item) => {
                                setSumFrom(item);
                            }}
                        />
                    </div>
                    <div>
                        <DecimalInputV2
                            label={"До"}
                            onChange={(item) => {
                                setSumTo(item);
                            }}
                        />
                    </div>
                </FlexRow>
            :
                <DecimalInputV2
                    label={baseT("conditionNumberValue")}
                    onChange={(item) => {
                        setValue({displayValue: item.toFixed(2), value: item.toFixed(2)});
                    }}
                />
        );
    }

    function renderQuantityValue() {
        if ((conditionType.displayName === "Количество") && (operation?.displayName === "Между")) {
            setValue({ displayValue: "0 и 0", value: "0 и 0" });
        } else {
            setValue({ displayValue: "0.00", value: "0.00" });
        }
        setConditionValueComp(
            (((conditionType.displayName === "Количество") && (operation?.displayName === "Между")) ?
                <FlexRow>
                    <div>
                        <NumberInput 
                            label={"От"}
                            onChange={(item) => {
                                setQuantityFrom(item);
                            }}
                        />
                    </div>
                    <div>
                        <NumberInput 
                            label={"До"}
                            onChange={(item) => {
                                setQuantityTo(item);
                            }}
                        />
                    </div>
                </FlexRow>
                :
                <NumberInput 
                    label={baseT("conditionNumberValue")}
                    onChange={(item) => {
                        setValue({displayValue: item.toFixed(2), value: item.toFixed(2)});
                    }}
                />
            )
        )
    }

    function renderContractorComp() {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={ContractorGroupAllSelectorModal}
                id={`inputAccompanyingSelectionContractor-${uuidv4()}`}
                inline={false}
                selectedEntity={contractorEntities?.[0]}
                selectedEntities={contractorEntities}
                label={baseT("selectionOfContractor")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setContractorEntities(entities);
                    setValue({
                        value: entities.map(e => e.idGlobal).join(','),
                        displayValue: entities.map(e => e.displayName).join(', ')
                    });
                    setSelectEntity(entities[0] ?? ({} as IEntitySimpleDTO));
                }}
                onClear={() => {
                    setContractorEntities([]);
                    setValue(undefined);
                    setSelectEntity({} as IEntitySimpleDTO);
                }}
            />
        );
    }

    function renderGoodsGroupComp() {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={GoodsGroupAllSelectorModal}
                id={`inputAccompanyingSelectionGoodsGroup-${uuidv4()}`}
                inline={false}
                selectedEntity={goodsGroupEntities[0]}
                selectedEntities={goodsGroupEntities}
                label={baseT("selectionOfGoodsGroup")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setGoodsGroupEntities(entities);
                    setValue(entities.length > 0 ? {
                        value: entities.map((entity) => entity.idGlobal).join(','),
                        displayValue: entities.map((entity) => entity.displayName).join(', '),
                    } : undefined);
                    setSelectEntity(entities[0] ?? ({} as IEntitySimpleDTO));
                }}
                onClear={() => {
                    setGoodsGroupEntities([]);
                    setValue(undefined);
                    setSelectEntity({} as IEntitySimpleDTO);
                }}
                disabled={props.lockFromPermission}
            />
        );
    }

    function renderStoreComp() {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={StoreSelectorModal}
                id={`inputAccompanyingSelectionStore-${uuidv4()}`}
                inline={false}
                selectedEntity={storeEntities?.[0]}
                selectedEntities={storeEntities}
                label={baseT("selectionOfStore")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setStoreEntities(entities);
                    setValue({
                        value: entities.map(e => e.idGlobal).join(','),
                        displayValue: entities.map(e => e.displayName).join(', ')
                    });
                    setSelectEntity(entities[0] ?? ({} as IEntitySimpleDTO));
                }}
                onClear={() => {
                    setStoreEntities([]);
                    setValue(undefined);
                    setSelectEntity({} as IEntitySimpleDTO);
                }}
            />
        );
    }

    function renderGoodsComp() {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={GoodsSelectorModal}
                id={`inputAccompanyingSelectionGoods-${uuidv4()}`}
                inline={false}
                selectedEntity={goodsEntities?.[0]}
                selectedEntities={goodsEntities}
                label={baseT("selectionOfGoods")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setGoodsEntities(entities);
                    setValue({
                        value: entities.map(e => e.idGlobal).join(','),
                        displayValue: entities.map(e => e.displayName).join(', ')
                    });
                    setSelectEntity(entities[0] ?? ({} as IEntitySimpleDTO));
                }}
                onClear={() => {
                    setGoodsEntities([]);
                    setValue(undefined);
                    setSelectEntity({} as IEntitySimpleDTO);
                }}
            />
        );
    }

    function renderDateComp() {
        const todayStr = DateTime.now().toFormat("yyyy-MM-dd");
        if (operation?.displayName !== "Между") {
            setValue({ displayValue: todayStr, value: todayStr });
        } else {
            setValue({ displayValue: todayStr + " и " + todayStr, value: todayStr + " и " + todayStr });
        }
        setConditionValueComp(
            (operation?.displayName === "Между") ?
                <FlexRow>
                    <DateInput
                        value={dateConditionFrom}
                        label={"От"}
                        onBlur={(val) => {
                            setDateConditionFrom(val);
                        }}
                    />
                    <DateInput
                        value={dateConditionTo}
                        label={"До"}
                        onBlur={(val) => {
                            setDateConditionTo(val);
                        }}
                    />
                </FlexRow>
            :
                <DateInput
                    value={dateCondition}
                    label={baseT("conditionDayOfTheWeekValue")}
                    onBlur={(val) => {
                        val && setValue({ displayValue: val.toFormat("yyyy-MM-dd"), value: val.toFormat("yyyy-MM-dd") });
                        setDateCondition(val);
                    }}
                />
        );
    }

    function renderStoreTypeComp() {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={StoreTypeSelectorModal}
                id={`inputAccompanyingSelectionStoreType-${uuidv4()}`}
                inline={false}
                selectedEntity={storeTypeEntities?.[0]}
                selectedEntities={storeTypeEntities}
                label={baseT("selectionOfStoreType")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setStoreTypeEntities(entities);
                    setValue({
                        value: entities.map(e => e.displayName).join(','),
                        displayValue: entities.map(e => e.displayName).join(', ')
                    });
                    setSelectEntity(entities[0] ?? ({} as IEntitySimpleDTO));
                }}
                onClear={() => {
                    setStoreTypeEntities([]);
                    setValue(undefined);
                    setSelectEntity({} as IEntitySimpleDTO);
                }}
            />
        );
    }

    function renderProducerComp() {
        setConditionValueComp(
            <GridMultipleSelectorInput
                selectorModalJsx={ProducerSelectorModal}
                id={`inputAccompanyingSelectionProducer-${uuidv4()}`}
                inline={false}
                selectedEntity={producerEntities?.[0]}
                selectedEntities={producerEntities}
                label={baseT("selectionOfProducer")}
                onSelect={(entities: IEntitySimpleDTO[]) => {
                    setProducerEntities(entities);
                    setValue({
                        value: entities.map(e => e.displayName).join(','),
                        displayValue: entities.map(e => e.displayName).join(', ')
                    });
                    setSelectEntity(entities[0] ?? ({} as IEntitySimpleDTO));
                }}
                onClear={() => {
                    setProducerEntities([]);
                    setValue(undefined);
                    setSelectEntity({} as IEntitySimpleDTO);
                }}
            />
        );
    }

    function renderBoolComp() {
        setValue({ displayValue: JnvlsOptios[0].displayName, value: "1" });
        setConditionValueComp(
            <SelectControl
                label={baseT("conditionNumberValue")}
                options={JnvlsOptios}
                onSelect={(item) => {
                    const value = item.displayName.toLocaleLowerCase() === 'да' ? '1' : item.displayName.toLocaleLowerCase() === 'нет' ? '2' : item.displayName
                    setValue({displayValue: item.displayName, value: value})
                }}
            />
        );
    }

    return (
        <div>
            <GridWrapper cols={2}>
                <div>
                    <div>
                        <GridSelectorInput
                            selectorModalJsx={ConditionSelectorModal}
                            id={`inputAccompanyingSelectionDiscountConditionType-${uuidv4()}`}
                            inline={false}
                            selectedEntity={conditionType}
                            label={baseT("selectionOfDiscountConditionType")}
                            onSelect={(entity) => {
                                setConditionValueComp(<></>);
                                setSelectEntity({} as IEntitySimpleDTO);
                                setContractorEntities([]);
                                setStoreEntities([]);
                                setGoodsEntities([]);
                                setGoodsGroupEntities([]);
                                setStoreTypeEntities([]);
                                setProducerEntities([]);
                                setDayOfTheWeekEntities([]);
                                setValue(undefined);
                                setSumFrom(0);
                                setSumTo(0);
                                setQuantityFrom(0);
                                setQuantityTo(0);
                                setTimeFrom("");
                                setTimeTo("");
                                setConditionType(entity);
                            }}
                            onClear={() => {
                                setConditionType({} as IEntitySimpleDTO);
                                setValue(undefined);
                                setOperation(undefined);
                            }}
                            disabled={props.lockFromPermission}
                        />
                    </div>
                    <SelectControl
                        id="conditionOperation"
                        label={baseT("conditionOperation")}
                        value={operation}
                        options={operationOption}
                        onSelect={(item) => {
                            setOperation(item);
                        }}
                        disabled={props.lockFromPermission}
                    />
                    {conditionValueComp}
                </div>
                
                <div>
                    <CommandsPanel
                        groups={[
                            [
                                {
                                    iconButton: btnAddEditCondition,
                                    text: btnText,
                                },
                                {
                                    iconButton: (
                                        <Delete2Button
                                            sizeVariant="mini"
                                            colorVariant="danger"
                                            onClick={() => {
                                                setDisplayItems([...displayItems.filter((item) => item.condition != selectedItem?.cells[0].value)]);
                                                props.onRemoveCondition(selectedItem?.cells[0].value);
                                                setSelectedItem(undefined);
                                            }}
                                            disabled={props.lockFromPermission}
                                        />
                                    ),
                                    text: "Удалить",
                                },
                                {
                                    iconButton: (
                                        <ClearButton
                                            sizeVariant="mini"
                                            colorVariant="danger"
                                            onClick={() => {
                                                setDisplayItems([]);
                                                props.onClearConditions();
                                                setValue(undefined);
                                                setOperation(undefined);
                                                setSelectedItem(undefined);
                                                setConditionType({} as IEntitySimpleDTO);
                                                setBtnText("Добавить условие");
                                                setTimeFrom("");
                                                setTimeTo("");
                                                setContractorEntities([]);
                                                setStoreEntities([]);
                                                setGoodsEntities([]);
                                                setGoodsGroupEntities([]);
                                                setStoreTypeEntities([]);
                                                setProducerEntities([]);
                                                setDayOfTheWeekEntities([]);
                                            }}
                                            disabled={props.lockFromPermission}
                                        />
                                    ),
                                    text: "Очистить все",
                                },
                            ],
                        ]}
                    />
                    <div className={light ? styles.light : ""}>
                        <DefaultGrid
                            gridId={uuidv4()}
                            data={displayItems}
                            totalCount={0}
                            plugin={props.plugin}
                            selectedItem={selectedItem}
                            filter={gridFilter}
                            onSelect={(row) => {
                                setSelectedItem(row);
                            }}
                            onSort={(i) => {
                                dispatchGridFilter({ type: "sort", payload: i.propertyName });
                            }}
                            onFilterDelete={(i) => {
                                dispatchGridFilter({
                                    type: "deleteColumnFilter",
                                    payload: i.propertyName,
                                });
                            }}
                            onPageNumberChange={(n) => {
                                dispatchGridFilter({
                                    type: "changePageNumber",
                                    payload: { pageNumber: n },
                                });
                            }}
                            onNumberPerPageChange={(n) => {
                                dispatchGridFilter({
                                    type: "changeNumberPerPage",
                                    payload: { numberPerPage: n },
                                });
                            }}
                            contextMenuItems={[
                                {
                                    name: "Удалить позицию",
                                    onClick: () => {
                                        if (selectedItem) {
                                            setDisplayItems([...displayItems.filter((item) => item.condition != selectedItem?.cells[0].value)]);
                                            props.onRemoveCondition(selectedItem?.cells[0].value);
                                            setSelectedItem(undefined);
                                        }
                                    },
                                },
                            ]}
                        ></DefaultGrid>
                    </div>
                </div>
            </GridWrapper>
            
            <SelectControl
                label={baseT("conditionJoinType")}
                value={conditionJoinType}
                options={conditionJoinTypeOption}
                onSelect={(item) => {
                    setConditionJoinType(item);
                    props.onConditionJoinType(item);
                }}
                disabled={props.lockFromPermission}
            />
            {showEditModal && (
                <BaseModalWindow
                    header="Редактировать условие"
                    ok={{
                        title: "ОК",
                        onClick: () => {
                            if (!selectedItem || !editText.trim()) return;
                            const oldText = selectedItem.cells[0].value;
                            setDisplayItems([
                                ...displayItems.filter((item) => item.condition !== oldText),
                                { condition: editText, id: selectedItem.id } as IDisplayItem,
                            ]);
                            props.onClick({
                                value: editText,
                                conditionType: conditionType,
                                rowValue: oldText,
                                operation: operation,
                                text: editText,
                                updateOrAdd: "update",
                            } as IProps);
                            setShowEditModal(false);
                        },
                    }}
                    cancel={{
                        title: "Отмена",
                        onClick: () => setShowEditModal(false),
                    }}
                >
                    <TextInput
                        label="Условие"
                        value={editText}
                        onChange={(val) => setEditText(val)}
                    />
                </BaseModalWindow>
            )}
        </div>
    );
};
